export const Menu = {
    global: {
        header: document.querySelector('.c-header_inner-container-content-mobile'),
        searchBar: document.querySelector('#searchBar'),
        searchInput: document.querySelector('#search'),
        mobile: window.matchMedia('(min-width: 0px) and (max-width: 767px)'),
        tablet: window.matchMedia('(min-width: 768px) and (max-width: 1199px)'),
        desktop: window.matchMedia('(min-width: 1200px)')
    },
    init: function () {
        this.event();
        this.stick();
        // /* On Resize
        // **************************************************************/
        // window.addEventListener('resize', function () {
        //     Menu.event();
        //     document.querySelector('.c-menu').style.height = `${document.querySelector('.c-menu-content').clientHeight}px`;
        // });
    },
    event: function () {
        document.querySelector('#menuIcon').addEventListener('click', function (e) {
            Menu.openMenu(e);
        });

        document.querySelector('#searchIcon').addEventListener('click', function (e) {
            Menu.toggleSearch(e);
        });

        let searchBtn = document.querySelector('#searchBtn');
        if (searchBtn) {
            document.querySelector('#searchBtn').addEventListener('click', function (e) {
                Menu.toggleSearch(e);
            });
        }

        let searchPageBtn = document.querySelector('#searchPageBtn');
        if (searchPageBtn) {
            document.querySelector('#searchPageBtn').addEventListener('click', function (e) {
                Menu.toggleSearch(e);
            });
        }

        let newsSearchBtn = document.querySelector('#newsSearchBtn');
        if (newsSearchBtn) {
            document.querySelector('#newsSearchBtn').addEventListener('click', function (e) {
                Menu.toggleSearch(e);
            });
        }

        document.querySelector('#searchClose').addEventListener('click', function (e) {
            Menu.toggleSearch(e);
        });
        // if (Menu.global.mobile.matches || Menu.global.tablet.matches) {
        //     document.querySelector('.c-menu_toggle').addEventListener('click', Menu.openMenu);
        //     document.querySelector('.c-menu_close').addEventListener('click', Menu.closeMenu);
        //     document.querySelector('.c-menu_nav').addEventListener('click', Menu.toggleSubmenu);

        //     // remove listeners
        //     document.querySelector('.c-menu_nav').removeEventListener('mouseover', Menu.displaySubmenu);
        //     Menu.global.header.removeEventListener('mouseout', Menu.hideSubmenu)
        // } else {
        //     if (Menu.global.desktop.matches) {
        //         document.querySelector('.c-menu_nav').addEventListener('mouseover', Menu.displaySubmenu);
        //         window.addEventListener('mouseover', Menu.hideSubmenu);

        //         // reset on resize
        //         Menu.disableScroll(false);
        //         Menu.closeMenu();

        //         let navItems = document.querySelectorAll('.c-menu_nav .c-menu_navList > li');
        //         if (navItems) {
        //             navItems.forEach((item) => {
        //                 item.classList.remove('animated');
        //             })
        //         }

        //         // remove listeners
        //         document.querySelector('.c-menu_toggle').removeEventListener('click', Menu.openMenu);
        //         document.querySelector('.c-menu_close').removeEventListener('click', Menu.closeMenu);
        //         document.querySelector('.c-menu_nav').removeEventListener('click', Menu.toggleSubmenu);
        //     }
        // }

        // document.querySelector('.c-menu_overlay').addEventListener('click', function () {
        //     Menu.closeMenu();
        // });

        // window.addEventListener('scroll', function () {
        //     Menu.stick();
        // });
    },
    // selectSubmenu: function(e) {
    //     let target = e.target.closest('.sub-menu > li')
    //     if (target) {
    //         target.classList.add('selected');
    //         target.parentElement.add('hovered');
    //     }
    // },
    displaySubmenu: function (e) {
        // if (e.target.closest('.c-menu-head')) {
        //     document.querySelector('.glasspanel').classList.add('visible');
        //     document.querySelectorAll('.c-menu_navList > li').forEach(el => {
        //         el.classList.remove('open')
        //     })
        //     if (!e.target.closest('.c-menu_navList > li').classList.contains('open')) {
        //         e.target.closest('.c-menu').classList.add('open');
        //         e.target.closest('.c-menu_navList > li').classList.add('open')
        //         e.target.closest('.c-menu').style.height = `${e.target.closest('.c-menu-content').offsetHeight + e.target.closest('.c-menu_navList > li').querySelector('.c-menu_submenu').scrollHeight}px`;
        //     }
        // }
        // if (e.target.closest('.sub-menu a')) {
        //     e.target.closest('.sub-menu li').classList.add('selected');
        //     e.target.closest('.sub-menu').classList.add('hovered');
        // }
    },
    hideSubmenu: function (e) {
        // if (!e.target.closest('.c-header .c-menu')) {
        //     document.querySelector('.glasspanel').classList.remove('visible');
        //     document.querySelectorAll('.c-menu_navList > li').forEach(el => {
        //         el.classList.remove('open')
        //     })
        //     if (document.querySelector('.c-menu').classList.contains('open')) {
        //         document.querySelector('.c-menu').classList.remove('open');
        //         document.querySelector('.c-menu').style.height = `${document.querySelector('.c-menu-content').offsetHeight}px`;
        //     }
        // }
        // if (!e.target.closest('.sub-menu li')) {
        //     document.querySelectorAll('.c-menu_navList > li .sub-menu li').forEach(el => {
        //         el.classList.remove('selected');
        //         el.parentElement.classList.remove('hovered');
        //     })
        // }
    },
    openMenu: function (e) {
        if (Menu.global.header.classList.contains('open')) {
            e.target.classList.remove('close');
            Menu.global.header.classList.remove('open');
            Menu.disableScroll(false);
        } else {
            Menu.global.header.classList.add('open');
            e.target.classList.add('close');
            Menu.disableScroll(true);
        }
        // Menu.prettyShow();
        // document.querySelector('.c-menu_nav').style.height = window.innerHeight + 'px';
    },
    toggleSearch: function (e) {
        if (Menu.global.searchBar.classList.contains('open')) {
            Menu.global.searchBar.classList.remove('open');
        } else {
            Menu.global.searchBar.classList.add('open');
            Menu.global.searchInput.focus();
        }
        // Menu.prettyShow();
        // document.querySelector('.c-menu_nav').style.height = window.innerHeight + 'px';
    },
    toggleSubmenu: function (e) {
        // let element = e.target.closest('li');
        // if (e.target.closest('.c-header .c-menu-head .icon')) {
        //     if (element.classList.contains('open')) {
        //         element.classList.remove('open');
        //         element.style.height = `${element.querySelector('.c-menu-head').offsetHeight}px`;
        //     } else {
        //         element.classList.add('open');
        //         element.style.height = `${element.scrollHeight}px`;
        //     }
        // }
    },
    closeMenu: function () {
        Menu.global.header.classList.remove('open');

        // let navItems = document.querySelectorAll('.c-menu_navList > li');
        // if (navItems) {
        //     navItems.forEach((item) => {
        //         item.classList.remove('animated');
        //         item.removeAttribute('style');
        //     });
        // }
        Menu.disableScroll(false);
        // setTimeout(() => {
        //     document.querySelector('.c-menu_nav').removeAttribute('style');
        // }, 500)
    },
    disableScroll: function (toggle) {
        let html = document.querySelector('html'),
            body = document.body,
            height = window.innerHeight;

        if (toggle == true) {
            html.style.height = height + 'px';
            body.style.height = height + 'px';
            html.classList.add('disableScroll');
        }
        else {
            html.style.height = '';
            body.style.height = '';
            html.classList.remove('disableScroll');
        }
    },
    prettyShow: function () {
        // let timer = new Array(),
        //     index = 1;
        // let navItems = document.querySelectorAll('.c-menu_nav .c-menu_navList > li');
        // if (navItems) {
        //     navItems.forEach((item) => {
        //         let delay;
        //         if (index === 1) {
        //             delay = 0;
        //         } else {
        //             delay = index * 200 + 40;
        //         }
        //         timer[index] = setTimeout(function () {
        //             item.classList.add('animated');
        //             clearTimeout(timer[index]);
        //         }, delay);
        //         index++;
        //     });
        // }

    },
    stick: function () {
        // if (window.scrollY > (Menu.global.header.offsetTop + Menu.global.header.offsetHeight)) {
        //     if (!Menu.global.header.classList.contains('sticky')) {
        //         Menu.global.header.classList.add('sticky');
        //     }
        // } else {
        //     Menu.global.header.classList.remove('sticky');
        // }
        // document.querySelector('.c-menu').style.height = `${document.querySelector('.c-menu-content').clientHeight}px`;
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/Menu.js